// assets
import { CalendarOutlined } from '@ant-design/icons';

// icons
const icons = {
  CalendarOutlined
};

// ==============================|| MENU ITEMS - UTILITIES ||============================== //

const utilities = {
  id: 'schedule',
  title: 'Schedule',
  type: 'group',
  children: [
    {
      id: 'walkthroughs',
      title: 'Walkthrough Scheduling',
      type: 'item',
      url: '/schedule/walkthrough',
      icon: icons.CalendarOutlined
    },
    {
      id: 'meetings',
      title: 'Meetings',
      type: 'item',
      url: '/schedule/meetings',
      icon: icons.CalendarOutlined
    }
  ]
};

export default utilities;
